// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"5d6542e8","255":"8b757b27"}[chunkId] + ".chunk.css";
};